"use strict";
/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateOrganisationSlug = void 0;
const crypto_1 = __importDefault(require("crypto"));
const DEFAULT_RANDOM_BYTES = 5;
/**
 * Generates the organisation slug which is used for creating dynamo tables
 * @param emailDomain - Email domain of the organisation
 * @returns - Slug as string
 */
const generateOrganisationSlug = (emailDomain) => {
    const randomBytes = crypto_1.default.randomBytes(DEFAULT_RANDOM_BYTES).toString('hex');
    const hyphenatedDomain = emailDomain.split('.').join('-');
    return `${randomBytes}-${hyphenatedDomain}`;
};
exports.generateOrganisationSlug = generateOrganisationSlug;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib3JnYW5pc2F0aW9uLXNsdWcuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvb3JnYW5pc2F0aW9uL3R5cGVzL29yZ2FuaXNhdGlvbi1zbHVnLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7O0dBTUc7Ozs7OztBQUVILG9EQUE0QjtBQUU1QixNQUFNLG9CQUFvQixHQUFHLENBQUMsQ0FBQztBQUUvQjs7OztHQUlHO0FBQ0ksTUFBTSx3QkFBd0IsR0FBRyxDQUFDLFdBQW1CLEVBQUUsRUFBRTtJQUM5RCxNQUFNLFdBQVcsR0FBRyxnQkFBTSxDQUFDLFdBQVcsQ0FBQyxvQkFBb0IsQ0FBQyxDQUFDLFFBQVEsQ0FBQyxLQUFLLENBQUMsQ0FBQztJQUM3RSxNQUFNLGdCQUFnQixHQUFHLFdBQVcsQ0FBQyxLQUFLLENBQUMsR0FBRyxDQUFDLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFDO0lBQzFELE9BQU8sR0FBRyxXQUFXLElBQUksZ0JBQWdCLEVBQUUsQ0FBQztBQUM5QyxDQUFDLENBQUM7QUFKVyxRQUFBLHdCQUF3Qiw0QkFJbkMifQ==